module.exports = __webpack_public_path__ + "img/scene5-9.5e4d52bb.png";